module.exports = "/fonts/vendor/typeface-inter/files/inter-latin-100.woff2?854e21985f8f3ac5347cd6b5703bd5cc";